import { gql } from '@apollo/client';

export const GET_PWI_WIDGET_OPTIONS = gql`
  query GetPwiWidgetOptions {
    vm {
      programs {
        programId
        name
      }
      tasks {
        taskId
        title
        taskItems {
          ... on VOLUNTEER_TaskItemFieldType {
            taskItemId
            field {
              __typename
              taskFieldId
              name
              ... on VOLUNTEER_MatrixTaskFieldType {
                rows {
                  matrixRowId
                  name
                }
              }
            }
          }
        }
      }
    }
  }
`;
